import script from "./Payment.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment.vue?vue&type=script&setup=true&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=3757c210&lang=less&scoped=true"
import "./Payment.vue?vue&type=style&index=1&id=3757c210&lang=less"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3757c210"]])

export default __exports__